import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

import { fetchContracts, resetCycle } from "../../../store/middleware";

function ContractsFilter({ util }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const filterEndDates = util.getListOfFilterEndDates();
  const filterStartDates = util.getListOfFilterStartDates();
  const { user } = useSelector((state) => state.userReducer);
  const { economicGroups, companies } = useSelector((state) => state.b2bCompaniesReducer);

  const [showModal, setShowModal] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 100,
    code: "",
    companyId: "",
    economicGroupId: "",
    startDate: "",
    endDate: "",
    active: "",
  });

  const applyFilters = (e) => {
    e.preventDefault();
    dispatch(fetchContracts(filter));
  };

  const clearFilters = () => {
    dispatch(
      fetchContracts({
        pageNumber: 1,
        pageSize: 100,
        code: "",
        companyId: "",
        economicGroupId: "",
        startDate: "",
        endDate: "",
        active: "",
      }),
    );
    setFilter({
      pageNumber: 1,
      pageSize: 100,
      code: "",
      companyId: "",
      economicGroupId: "",
      startDate: "",
      endDate: "",
      active: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "companyId" || name === "economicGroupId") {
      setFilter((state) => ({ ...state, [name]: Number(value) }));
    } else {
      setFilter((state) => ({ ...state, [name]: value }));
    }
  };

  const statusOptions = [
    { label: "Select", value: "" },
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];

  const handleResetCycle = async () => {
    await dispatch(resetCycle("cycle"));

    setShowModal(!showModal);
    setShowModalMessage(!showModalMessage);
  };

  const handleOpenModalConfirm = () => {
    setShowModal(true);
  };

  return (
    <div className="bigBox">
      <h2>
        <i className="fa fa-filter" aria-hidden="true"></i>Filters
      </h2>
      <form onSubmit={applyFilters}>
        <div className="formulario">
          <div className="lineInput">
            <label>{t("CONTRACT_NUMBER")}</label>
            <input placeholder="Contract number" name="code" onChange={handleChange} value={filter.code} />
          </div>

          <div className="lineInput">
            <label>{t("ECONOMIC_GROUP")}</label>
            <select name="economicGroupId" value={filter.economicGroupId} onChange={handleChange}>
              <option value="0">Select</option>
              {economicGroups.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInput">
            <label>{t("COMPANY")}</label>
            <select name="companyId" value={filter.companyId} onChange={handleChange}>
              <option value="0">Select</option>
              {companies?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.socialName}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInput">
            <label>{t("PERIOD_START")}</label>
            <select name="startDate" value={filter.startDate} onChange={handleChange}>
              <option value="">Select</option>
              {filterStartDates.map((item) => {
                return (
                  <option value={item.value} key={JSON.stringify(item.value)}>
                    {item.description}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="lineInput">
            <label>{t("PERIOD_END")}</label>
            <select name="endDate" value={filter.endDate} onChange={handleChange}>
              <option value="">Select</option>
              {filterEndDates.map((item) => {
                return (
                  <option value={item.value} key={JSON.stringify(item)}>
                    {item.description}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="lineInput">
            <label>Status</label>
            <select name="active" value={filter.active} onChange={handleChange}>
              {statusOptions.map((option) => {
                return (
                  <option value={option.value} key={option.label}>
                    {option.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="filtersBottom">
          <div className="items tiny"></div>
          <div className="items large text-center">
            <div className="show-extras"></div>
          </div>
          <div className="items tiny buttons text-right">
            {user?.role === "companyManager" && (
              <button className="buttonRight" type="button" onClick={() => handleOpenModalConfirm()}>
                <i className="fa fa-refresh" aria-hidden="true" /> {t("NEW_BTN_RESET_CYCLE")}
              </button>
            )}
            <button type="button" className="btn-clear-filter" onClick={clearFilters}>
              {t("CLEAR_FILTERS")}
            </button>
            <button type="submit" className="btn-filter">
              {t("FILTER")}
            </button>
          </div>
        </div>
      </form>
      <Dialog maxWidth="sm" className="newDialog" open={showModal} onClose={() => setShowModal(!showModal)}>
        <DialogTitle className="dialogTitle">{t("NEW_BTN_RESET_CYCLE")}</DialogTitle>
        <DialogContent className="dialogContent">
          <p>{t("MESSAGE_RESET_CYCLE")}</p>
        </DialogContent>

        <div className="dialogActions">
          <div className="buttons">
            <button className="rateLater" onClick={() => setShowModal(!showModal)}>
              {t("CANCEL")}
            </button>
            <button className="rate" onClick={() => handleResetCycle()}>
              {t("CONFIRM")}
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        maxWidth="sm"
        className="newDialog"
        open={showModalMessage}
        onClose={() => setShowModalMessage(!showModalMessage)}
      >
        <DialogTitle className="dialogTitle">{t("NEW_BTN_RESET_CYCLE")}</DialogTitle>
        <DialogContent className="dialogContent">
          <p>{t("MESSAGE_BACK_RESET_CYCLE")}</p>
        </DialogContent>

        <div className="dialogActions">
          <div className="buttons">
            <button className="rate" onClick={() => setShowModalMessage(!showModalMessage)}>
              {t("OK")}
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ContractsFilter;
